var productData =document.querySelector('#productData[type="application/json"]')
var mediaJson = document.querySelector('#product-media[type="application/json"]')
var variantMeta = document.querySelector('#pVarMetafields[type="application/json"]')
var variantMetaParse = JSON.parse(variantMeta.textContent)
var varMetaParse = JSON.parse(variantMetaParse.replace(/\n*/g,""))
var parseProductData = JSON.parse(productData.textContent)
var parseMediaJson = JSON.parse(mediaJson.textContent)
var imagesContainer = document.querySelector(".m-product-media--list") 
var firstImg = imagesContainer.querySelector("img")
var variants = {}
parseProductData.variants.forEach((element) => {
  console.log("element",element)
  if(element.featured_image){
    variants[element.id] = element.featured_image.src
  }
});
var listImgsContainer = imagesContainer.querySelectorAll("img")
var variantElement = document.querySelectorAll(".variant-title-selected")
var metaElement = document.querySelectorAll(".meta-title-selected")

document.addEventListener("change",()=>{
  var query = window.location.search
  if( query.includes("?variant=")){

    var varNumber = query.replace("?variant=","")
    var listImgs=[]

    var selected 
    var hasDeco
    
    parseProductData.variants.forEach((data)=>{
      if(data.id == varNumber){
        selected= data.title
        hasDeco = varMetaParse[`${data.id}`]        
      }
    })

    variantElement.forEach((elm)=>{
      elm.innerText=selected
    })

    metaElement.forEach((elm)=>{
      elm.innerText=hasDeco.decoTitle +" "
    })
    var espeContainer= document.querySelector("#especificaciones_variant")
    if(espeContainer){
      let texto = hasDeco.especificaciones.replaceAll("-","\n -")
      console.log("texto",texto)
      espeContainer.innerText = texto
    }

    var empieza = false
    parseMediaJson.forEach((data)=>{
      if (data.src == variants[varNumber]) {
        empieza = true;
      }
      if(empieza == true && listImgsContainer.length > listImgs.length ){
        listImgs.push(data.src)
      }
    })

    if(parseMediaJson.length > parseProductData.variants.length * 3 ){
      listImgsContainer.forEach((img,index)=>{
        var aux = img.parentNode;
        var containerImg = aux.parentNode
        var zoomIcon = containerImg.parentNode.querySelector(".m-product-media--zoom-icon")
        img.setAttribute("srcset","")
        img.setAttribute("src",listImgs[index])
        img.setAttribute("onclick",`imageZoom('${listImgs}','${listImgs[index]}')`)
        img.removeAttribute("lazy")
        zoomIcon.setAttribute("onclick",`imageZoom('${listImgs}','${listImgs[index]}')`)
      })
    }else{
      if(listImgs[0] != undefined){
        var aux = listImgsContainer[0].parentNode;
        var containerImg = aux.parentNode
        var zoomIcon = containerImg.parentNode.querySelector(".m-product-media--zoom-icon")
        listImgsContainer[0].setAttribute("srcset","")
        listImgsContainer[0].setAttribute("src",listImgs[0])
        listImgsContainer[0].setAttribute("onclick",`imageZoom('${listImgs}','${listImgs[0]}')`)
        zoomIcon.setAttribute("onclick",`imageZoom('${listImgs}','${listImgs[0]}')`)
      }
    }
  }
  
}) 

function imageZoom(list,actual){
  setTimeout(() => {
    var photoSwipe = document.getElementsByClassName("pswp--open")[0]
    photoSwipe.style.display="none"
    var parentPhotoswipe = photoSwipe.parentNode
    parentPhotoswipe.append(zoomSliderContainer)
    var swiperEl = zoomSliderContainer.querySelector('swiper-container');
    swiperEl.swiper.slideTo(posicion,0)
  }, 2);
  var listado = list.split(",")
  
  var zoomSliderContainer = document.createElement("div")
  zoomSliderContainer.setAttribute("class","zoom-slider-container")
  zoomSliderContainer.setAttribute("id","productoSlider")
  var zoomSlider = document.createElement("div")
  zoomSlider.setAttribute("class","zoom-slider")
  var swiperContainer = document.createElement("swiper-container")
  swiperContainer.setAttribute("class","mySwiper")
  // swiperContainer.setAttribute("navigation-clickable","true")
  // swiperContainer.setAttribute("navigation","true")
  swiperContainer.setAttribute("space-between","30")
  swiperContainer.setAttribute("loop","true")
  var posicion 
  listado.forEach((element,index)=>{
    var swiperSlide = document.createElement("swiper-slide")
    var img = document.createElement("img")
    img.setAttribute("src",element)
    img.setAttribute("onclick","zoomSliderImage(this)")
    swiperSlide.append(img)
    swiperContainer.append(swiperSlide)
    if(element == actual){
      posicion=index
    }
  })
  zoomSlider.append( swiperContainer )
  zoomSliderContainer.append( zoomSlider )

  
  
  var buttonContainer = document.createElement('div')
    buttonContainer.setAttribute('class','container-buttons')
  var buttonContain = document.createElement('div')
    buttonContain.setAttribute('class','buttons-container')

  var buttonLeft = document.createElement('div')
  buttonLeft.setAttribute('onclick','prevSlide("#productoSlider")')
  buttonLeft.setAttribute('class','arrow-left')
  buttonLeft.innerHTML=`<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
      <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18" />
    </svg>
    `
  var buttonRight = document.createElement('div')
  buttonRight.setAttribute('onclick','nextSlide("#productoSlider")')
  buttonRight.setAttribute('class','arrow-right')
  buttonRight.innerHTML=`<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
      <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3" />
    </svg>
    `
  var buttonClose = document.createElement('div')
  buttonClose.setAttribute('onclick','closeSlide("#productoSlider")')
  buttonClose.setAttribute('class','close-icon')
  buttonClose.innerHTML=`<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
      <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
    </svg>
    `
  buttonContain.append(buttonLeft)
  buttonContain.append(buttonClose)
  buttonContain.append(buttonRight)
  buttonContainer.append(buttonContain)
  zoomSlider.append(buttonContainer)
}

function closeSlide(id) {
  var container = document.querySelector(id);
  var parentContainer= container.parentNode;
  parentContainer.removeChild(container);
}  
function zoomSliderImage(elm) {
  if(elm.style.transform == "scale(1.3)"){
    elm.style.transform="scale(1)"

  }else{
    
    elm.style.transform="scale(1.3)"

  }

  
}


